import React, { useState, useEffect, createRef } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { withRouter } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { selectRow } from "../state/reducers/eomSlice";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { Multiselect } from "multiselect-react-dropdown";
import eomMasterService from "../services/eom-master-service";
import { clearSelectedRow } from "../state/reducers/eomSlice";

const CreateMaster = ({ history }) => {
  let { selectedRow, year } = useSelector(selectRow);
  const { id } = useParams();
  const { register, handleSubmit, errors } = useForm({});
  const [details, setdetails] = useState();
  const [loading, setLoading] = useState(false);
  const [parentList, setParentList] = useState([]);
  const [parent, setParent] = useState(
    selectedRow?.payor ? [selectedRow.payor] : []
  );
  const [groupList, setGroupList] = useState([]);
  const [group, setGroup] = useState(
    selectedRow?.group ? [selectedRow?.group] : []
  );
  const [chargeCodeList, setChargeCodeList] = useState([]);
  const [chargeCode, setChargeCode] = useState(
    selectedRow?.unique ? [selectedRow?.unique] : []
  );
  const [showError, setShowError] = useState(false);
  const [invoice, setInvoice] = useState("");
  const [facilty, setFacility] = useState("");
  const [regional, setRegional] = useState("");
  const [facilityCharged, setFacilityCharged] = useState("");
  const [modified, setModified] = useState(true);
  const [pSearch, setPSearch] = useState([]);
  const [gSearch, setGSearch] = useState([]);
  const [uSearch, setUSearch] = useState([]);

  const dispatch = useDispatch();
  const multiselectRef = createRef();
  const multiselectRef1 = createRef();
  const multiselectRef2 = createRef();

  useEffect(() => {
    if (id) getData(id);
  }, [id]);
  useEffect(() => {
    getParents();
    return function cleanup() {
      dispatch(clearSelectedRow());
    };
  }, []);

  useEffect(() => {
    if (details?.payor && parentList?.length > 0 && modified) {
      setParent([details?.payor]);
    }
    if (details?.group && groupList?.length > 0 && modified) {
      setGroup([details?.group]);
    }
    if (details?.unique && chargeCodeList?.length > 0 && modified) {
      setChargeCode([details?.unique]);
    }
  }, [details, groupList, chargeCodeList, parentList]);

  const getData = async () => {
    try {
      if (!id) return;
      setLoading(true);
      const resp = await eomMasterService.getData(id);
      setdetails(resp);
      setFacilityCharged(resp?.facility_charged);
      setRegional(resp?.regional);
      setFacility(resp?.facility_name);
      setInvoice(resp?.invoice);

      getParents();
      getGroups([resp?.payor]);
      getChargeCodes([resp?.payor], [resp?.group]);

      
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error while getting  details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const getParents = async () => {
    try {
      let resp = await eomMasterService.getPayors();
      if (resp) {
        setParentList(resp);
      }
      if (id) {
        setParent(resp?.payor);
      }
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting payors. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const getGroups = async (parent) => {
    let totalGroupList = [];
    try {
      totalGroupList = await eomMasterService.getGroupCodes(parent.join(","));
      setGroupList(totalGroupList);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting groups. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  const getChargeCodes = async (parent, group) => {
    try {
      var codes = await eomMasterService.getUniqueCodes(
        parent.join(","),
        group.join(",")
      );
      setChargeCodeList(codes);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error getting charge codes. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const onSubmit = async () => {
    try {
      
      let data = {};
      data["regional"] = regional;
      data["facility_name"] = facilty;
      data["invoice"] = invoice;
      data["payor"] = parent?.length ? parent.join(",") : pSearch.join(",");
      data["group"] = group?.length ? group.join(",") : gSearch.join(",");
      data["unique"] = chargeCode?.length
        ? chargeCode.join(",")
        : uSearch.join(",");
      data["facility_charged"] = facilityCharged;
      if(!data?.payor?.length || !data?.group?.length){
        return
      }
      setLoading(true);
      
      if (id) {
        data["id"] = id;
        await eomMasterService.updateData(data);
      } else {
        await eomMasterService.createData(data);
      }
      if (year) {
        await history.push("/eom");
      } else {
        await history.push("/master");
      }

      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting  details. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };
  return (
    <>
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00B2A9"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <CipHeader />
      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3 w-full">
          <div className="w-full text-darkclr font-semibold leading-10 ">
            <span className="text-xl">{id ? "EDIT" : "CREATE"}</span>
          </div>
        </div>
        <div className="px-12 py-5">
          <form onSubmit={handleSubmit(onSubmit)}>
            <ul className="text-left">
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Parent
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>

                {parentList ? (
                  <Multiselect
                    name="payor"
                    selectedValues={parent}
                    isObject={false}
                    displayValue="name"
                    options={parentList}
                    ref={multiselectRef}
                    selectionLimit={1}
                    onSearch={(val) => setPSearch([val])}
                    onSelect={(e) => {
                      setModified(false);
                      let currentValue =
                        multiselectRef.current.getSelectedItems();
                      setParent(currentValue);
                      getGroups(currentValue);
                      // setGroup([selectedRow?.group]);
                      // setChargeCode([selectedRow?.unique]);
                      // multiselectRef1.current.resetSelectedValues();
                      // multiselectRef2.current.resetSelectedValues();
                    }}
                    onRemove={(e) => {
                      setParent([]);
                    }}
                  />
                ) : (
                  ""
                )}
                {!(parent?.length || pSearch?.length) && showError && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    You must select parent
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Group
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>

                {groupList ? (
                  <Multiselect
                    selectedValues={group}
                    options={groupList}
                    name="grpList"
                    isObject={false}
                    displayValue="group"
                    ref={multiselectRef1}
                    onSearch={(val) => setGSearch([val])}
                    selectionLimit={1}
                    onSelect={(e) => {
                      setModified(false);
                      let currentValue =
                        multiselectRef1.current.getSelectedItems();
                      setGroup(currentValue);
                      getChargeCodes(parent, currentValue);
                      // setChargeCode("");
                      // multiselectRef2.current.resetSelectedValues();
                    }}
                    onRemove={(e) => {
                      setGroup([]);
                    }}
                  />
                ) : (
                  ""
                )}
                {!(group?.length || gSearch?.length) && showError && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    You must select group
                  </p>
                )}
              </li>

              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Charge Code
                </label>

                {chargeCodeList ? (
                  <Multiselect
                    name="codeList"
                    displayValue="name"
                    isObject={false}
                    selectedValues={chargeCode}
                    options={chargeCodeList}
                    onSearch={(val) => setUSearch([val])}
                    ref={multiselectRef2}
                    selectionLimit={1}
                    onSelect={(e) => {
                      setModified(false);
                      let currentValue =
                        multiselectRef2.current.getSelectedItems();
                      setChargeCode(currentValue);
                    }}
                    onRemove={(e) => {
                      setChargeCode("");
                    }}
                  />
                ) : (
                  ""
                )}
                
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Facility charged
                </label>
                <span className="text-xs md:text-sm text-hlred ml-1">*</span>

                <input
                  id="facility_charged"
                  name="facility_charged"
                  type="text"
                  placeholder="Facility charged"
                  value={facilityCharged}
                  onChange={(e) => setFacilityCharged(e.target.value)}
                  ref={register({
                    required: "You must specify facility",
                  })}
                  className={` ${
                    errors.facility_charged ? "border-red-400" : ""
                  } border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm`}
                />

                {errors.facility_charged && (
                  <p className="text-xs md:text-sm md:pt-1 text-hlred">
                    {errors.facility_charged?.message}
                  </p>
                )}
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  SHP Invoice NO
                </label>
                <input
                  id="invoice"
                  name="invoice"
                  type="text"
                  value={invoice}
                  placeholder="SHP Invoice NO"
                  onChange={(e) => setInvoice(e.target.value)}
                  className={
                    "border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                  }
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Facility name
                </label>

                <input
                  id="facility_name"
                  name="facility_name"
                  type="text"
                  value={facilty}
                  onChange={(e) => setFacility(e.target.value)}
                  placeholder="Facility name"
                  className={
                    "border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                  }
                />
              </li>
              <li className="inline-block text-xs leading-6 text-menu_txt w-full mb-3">
                <label className="text-labelclr font-semibold text-sm tracking-wider">
                  Regional
                </label>
                <input
                  id="regional"
                  name="regional"
                  type="text"
                  placeholder="Regional"
                  onChange={(e) => setRegional(e.target.value)}
                  value={regional}
                  className={
                    "border focus:outline-none h-11 rounded-md pl-2 font-normal w-full text-fogotpwsd_login text-sm"
                  }
                />
              </li>

              <li className="inline-block text-sm leading-8 w-full">
                <button
                  type="submit"
                  className="rounded font-medium h-10 text-white w-full bg-login_btn my-3 focus:outline-none text-sm"
                  aria-label="Create user"
                  onClick={() => setShowError(true)}
                >
                  SUBMIT
                </button>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(CreateMaster)
);
